(function () {
  function init(bar) {
    var target = document.getElementById(bar.dataset.target);
    if (!target) return;

    var priceSource = document.getElementById(bar.dataset.priceSource);
    var stickyPrice = bar.querySelector('.trypooh-sticky-atc__price');

    bar.removeAttribute('hidden');

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
    }, { threshold: 0 });
    io.observe(target);

    if (priceSource && stickyPrice) {
      var mo = new MutationObserver(function () {
        stickyPrice.innerHTML = priceSource.innerHTML;
      });
      mo.observe(priceSource, { childList: true, subtree: true, characterData: true });
    }
  }

  function run() {
    document.querySelectorAll('.trypooh-sticky-atc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
